const PROFILE_STAFF_FIELDS = 'id:user_id, first_name, last_name, email';

const ROSTER_STAFF_FIELDS = 'id:user_id, first_name, last_name';

const DIRECTORY_FIELDS = 'id:user_id, first_name, last_name, email, '
  + 'staff:staff!staff_user_id_fkey(sub_role, availability, away_reason, away_until, last_active_at, calendly_event_type_uri, calendly_session_event_type_uri, created_at)';

const PERMISSION_FIELDS = 'action, sub_role';

const FACTORS_PATH = '/auth-staff/factors';

const FACTOR_RESET_PATH = '/auth-staff/factor-reset';

const AVAILABILITIES = ['active', 'away', 'inactive'] as const;

const AWAY_REASONS = ['vacation', 'sick_leave', 'other'] as const;

const STAFF_HOLD_KINDS = ['applicant', 'member'] as const;

const ROUND_ROBIN = 'round_robin';

export {
  AVAILABILITIES,
  AWAY_REASONS,
  DIRECTORY_FIELDS,
  FACTORS_PATH,
  FACTOR_RESET_PATH,
  PERMISSION_FIELDS,
  PROFILE_STAFF_FIELDS,
  ROSTER_STAFF_FIELDS,
  ROUND_ROBIN,
  STAFF_HOLD_KINDS,
};
